import { render, staticRenderFns } from "./ChangeProfile.vue?vue&type=template&id=2309da6c&scoped=true&"
import script from "./ChangeProfile.vue?vue&type=script&lang=js&"
export * from "./ChangeProfile.vue?vue&type=script&lang=js&"
import style0 from "./ChangeProfile.vue?vue&type=style&index=0&id=2309da6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2309da6c",
  null
  
)

export default component.exports